import RepairFileOriginTypeConstant from '@/constants/repair-module/repair-file/repairFileOriginTypeConstant'
import RepairFileEndStatusConstant from '@/constants/repair-module/repair-file/repairFileEndStatusConstant'
import RepairFileStatusMacroConstant from '@/constants/repair-module/repair-file/repairFileStatusMacroConstant'

export function isReplacementEstimateOffer(offer) {
  const offerType = offer?.offer_type?.toUpperCase()
  return (
    offerType === RepairFileEndStatusConstant.PRODUCT_REPLACED_STANDARD ||
    offerType === RepairFileEndStatusConstant.PRODUCT_REPLACED_SUPERIOR
  )
}

const KEY_ACCOUNT_LOCKED_STATUS_MACROS = [
  RepairFileStatusMacroConstant.DRAFT,
  RepairFileStatusMacroConstant.IN_CREATION,
  RepairFileStatusMacroConstant.IN_CREATION_ESTIMATE,
  RepairFileStatusMacroConstant.IN_CREATION_PROSPECT
]

export function getRepairFilePayload(repairFile) {
  return repairFile?.raw || repairFile
}

export function isKeyAccountRepairFile(repairFile) {
  return getRepairFilePayload(repairFile)?.origin_type === RepairFileOriginTypeConstant.KEY_ACCOUNT
}

export function hasUnreadKeyAccountNotification(repairFile) {
  const repairFilePayload = getRepairFilePayload(repairFile)

  return (
    isKeyAccountRepairFile(repairFilePayload) &&
    repairFilePayload?.has_unread_key_account_notification === true
  )
}

export function shouldShowKeyAccountOpeningWarning(repairFile) {
  const repairFilePayload = getRepairFilePayload(repairFile)

  return (
    isKeyAccountRepairFile(repairFilePayload) &&
    repairFilePayload?.key_account_warning_acknowledged !== true
  )
}

export function isLockedKeyAccountRepairFile(repairFile) {
  const repairFilePayload = getRepairFilePayload(repairFile)

  return (
    isKeyAccountRepairFile(repairFilePayload) &&
    KEY_ACCOUNT_LOCKED_STATUS_MACROS.includes(repairFilePayload?.status_macro)
  )
}
